let Test = require('@/mixins/Forms/2022/NRCA_LTO_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.8.5.1)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Boolean`,
                            question: `The automatic scheduling controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.8.5.1(a)`,
                            answer: false
                        },
                        row_2: {
                            id: `2`,
                            type: `Boolean`,
                            question: `The automatic scheduling control is programmed with on and off schedules that match the schedules in the construction documents. <b>OR</b><br> If the schedule is unknown, the programmed schedule matches the default schedule where the off schedule is from 12:00 A.M. to 6:00 A.M. and the on schedule is all other nigttime hours, 7 days per week.`,
                            code_reference: `NA7.8.5.1(b)`,
                            answer: false
                        },
                        row_3: {
                            id: `3`,
                            type: `Boolean`,
                            question: `The lighting control programming includes on and off schedules for weekdays, weekends, and holidays (if applicable).`,
                            code_reference: `NA7.8.5.1(c)`,
                            answer: false
                        },
                        row_4: {
                            id: `4`,
                            type: `Boolean`,
                            question: `The correct time and date are properly set in the control.`,
                            code_reference: `NA7.8.5.1(d)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: `Functional Testing (NA7.8.5.2)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Boolean`,
                            question: `During daytime simulation, all controlled luminaires are turned off.`,
                            code_reference: `NA7.8.5.2(a), Section 130.2(c)1, Section 160.5(c)2A`,
                            answer: false
                        },
                        row_2: {
                            id: `2`,
                            type: `Boolean`,
                            question: `During nighttime simulation with programme occupied period, all controlled luminaires are turned on.`,
                            code_reference: `NA7.8.5.2(b), Section 130.2(c)2C, Section 160.5(c)2Biii`,
                            answer: false
                        },
                        row_3: {
                            id: `3`,
                            type: `Boolean`,
                            question: `During nighttime simulation with the programmed occupied period, the controlled luminaires are turned off or the lighting power of controlled luminaires is reduced by at least 50% and no more than 90%.`,
                            code_reference: `NA7.8.5.2(c), Section 130.2(c)2B, Section 130.2(c)2C, Section 160.5(c)2Bii, Section 160.5(c)2Biii`,
                            answer: false
                        },
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },
}
